import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, renderSlot as _renderSlot, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'


const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "text-red-lp-100" }
const _hoisted_3 = {
  class: "absolute inset-y-0 right-0 flex items-center px-2",
  style: {"cursor":"pointer"}
}
const _hoisted_4 = {
  class: 
        `select w-full bg-white absolute border border-t-0 border-gray-lp-400 rounded-b-md px-4 z-50 overflow-x-show`
      ,
  style: {"max-height":"80vh"}
}
const _hoisted_5 = { class: " text-red-lp-100 absolute top-0 right-0 mt-2 mr-2" }
const _hoisted_6 = {
  key: 0,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_7 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_8 = {
  key: 1,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_9 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_10 = {
  key: 2,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_11 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_12 = {
  key: 3,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_13 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_14 = { class: "flex flex-row space-x-2" }
const _hoisted_15 = { class: "w-2/5" }
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = {
  key: 4,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }, " Status ", -1)
const _hoisted_19 = {
  key: 5,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }, " Consolidator ", -1)
const _hoisted_21 = { class: "flex flex-row space-x-2" }
const _hoisted_22 = { class: "w-full" }
const _hoisted_23 = {
  key: 6,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }, " Kota Hub ", -1)
const _hoisted_25 = { class: "flex flex-row space-x-2" }
const _hoisted_26 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: 
      `advanced-filter inline-block relative bottom-0 left-0 text-12px xxl:text-14px mr-2 ${_ctx.openFilter &&
        'w-300px'}`
    
  }, [
    _createVNode("div", {
      class: 
        `bg-white ${
          _ctx.openFilter && !_ctx.isDisabled ? 'rounded-t' : 'rounded'
        } border text-black-lp-300 leading-tight px-3 py-2.5 xxl:py-2.5 pr-8 font-normal`
      ,
      style: {"cursor":"pointer"},
      onClick: _cache[2] || (_cache[2] = 
        () => {
          _ctx.openFilter = !_ctx.openFilter;
        }
      )
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", {
          class: _ctx.isDisabled && 'opacity-50'
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("posBranch.list.filter.filter")) + " ", 1),
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.sumFilter !== 0 ? `(${_ctx.sumFilter})` : ""), 1)
        ], 2)
      ]),
      _createVNode("div", _hoisted_3, [
        (_ctx.openFilter)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: _imports_0,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`,
              alt: "up"
            }, null, 2))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              src: _imports_1,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`,
              onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.isChevron = true;
            }
          ),
              alt: "down"
            }, null, 2))
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _withDirectives(_createVNode("div", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
        class: "relative cursor-pointer w-full mb-4"
      }, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("posBranch.list.filter.reset")), 1)
      ], 512), [
        [_vShow, _ctx.sumFilter > 0]
      ]),
      (!_ctx.isHubList)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("posBranch.list.filter.contractStatus")), 1),
            _createVNode(_component_Select, {
              class: "w-full",
              dataSelect: _ctx.statusContract,
              onOpenSelect: () => (_ctx.openStatusContract = true),
              onCloseSelect: () => (_ctx.openStatusContract = false),
              onChooseSelect: 
            (name, val) => {
              _ctx.filterData.statusContract = val;
              _ctx.openStatusContract = false;
              _ctx.onChange();
            }
          ,
              value: _ctx.filterData.statusContract,
              isOpenMenu: _ctx.openStatusContract
            }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isHubList)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("posBranch.list.filter.partnerStatus")), 1),
            _createVNode(_component_Select, {
              class: "w-full",
              dataSelect: _ctx.statusPartner,
              onOpenSelect: () => (_ctx.openStatusPartner = true),
              onCloseSelect: () => (_ctx.openStatusPartner = false),
              onChooseSelect: 
            (name, val) => {
              _ctx.filterData.statusPartner = val;
              _ctx.openStatusPartner = false;
              _ctx.onChange();
            }
          ,
              value: _ctx.filterData.statusPartner,
              isOpenMenu: _ctx.openStatusPartner
            }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isPosRoute)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("posBranch.list.filter.posType")), 1),
            _createVNode(_component_Select, {
              class: "w-full",
              dataSelect: _ctx.posType,
              onOpenSelect: () => (_ctx.openTypePos = true),
              onCloseSelect: () => (_ctx.openTypePos = false),
              onChooseSelect: 
            (name, val) => {
              _ctx.filterData.posType = val;
              _ctx.openTypePos = false;
              _ctx.onChange();
            }
          ,
              value: _ctx.filterData.posType,
              isOpenMenu: _ctx.openTypePos
            }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isHubList)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("posBranch.list.filter.originCity")), 1),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_SelectSearch, {
                  onChevron: _cache[4] || (_cache[4] = e => (_ctx.isChevron = e)),
                  onFilter: _cache[5] || (_cache[5] = e => _ctx.fetchOriginDestination(e, 'code')),
                  onFocus: _cache[6] || (_cache[6] = () => _ctx.fetchOriginDestination('', 'code')),
                  isLoading: _ctx.loadingOriginDestination,
                  options: _ctx.originList,
                  keyName: "code",
                  keyValue: "code",
                  placeholder: _ctx.$t(`partnerManagement.code`),
                  modelValue: _ctx.filterData.originCity,
                  "onUpdate:modelValue": [
                    _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterData.originCity = $event)),
                    _ctx.onChange
                  ],
                  class: "mb-2",
                  isShowIconEmpty: ""
                }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"])
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode(_component_SelectSearch, {
                  onChevron: _cache[8] || (_cache[8] = e => (_ctx.isChevron = e)),
                  onFilter: _cache[9] || (_cache[9] = e => _ctx.fetchOriginDestination(e, 'name')),
                  onFocus: _cache[10] || (_cache[10] = () => _ctx.fetchOriginDestination('', 'name')),
                  isLoading: _ctx.loadingOriginDestination,
                  options: _ctx.originList,
                  keyName: "name",
                  keyValue: "code",
                  placeholder: _ctx.$t(`sttPaidUnpaid.placeholderCityDestination`),
                  modelValue: _ctx.filterData.originCity,
                  "onUpdate:modelValue": [
                    _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterData.originCity = $event)),
                    _ctx.onChange
                  ],
                  class: "mb-2"
                }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isHubList)
        ? (_openBlock(), _createBlock("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_Select, {
              class: "w-full",
              dataSelect: _ctx.status,
              onOpenSelect: () => (_ctx.openStatus = true),
              onCloseSelect: () => (_ctx.openStatus = false),
              onChooseSelect: 
            (name, val) => {
              _ctx.filterData.status = val;
              _ctx.openStatus = false;
              _ctx.onChange();
            }
          ,
              value: _ctx.filterData.status,
              isOpenMenu: _ctx.openStatus
            }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isHubList)
        ? (_openBlock(), _createBlock("div", _hoisted_19, [
            _hoisted_20,
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode(_component_SelectSearch, {
                  onChevron: _cache[12] || (_cache[12] = e => (_ctx.isChevron = e)),
                  onFilter: _cache[13] || (_cache[13] = e => _ctx.fetchListConsolidator(e, 'name')),
                  onFocus: _cache[14] || (_cache[14] = () => _ctx.fetchListConsolidator('', 'name')),
                  isLoading: _ctx.loadingConsolidator,
                  options: _ctx.consolidatorList,
                  keyName: "name",
                  keyValue: "id",
                  placeholder: "Pilih consolidator",
                  modelValue: _ctx.filterData.consolidator,
                  "onUpdate:modelValue": [
                    _cache[15] || (_cache[15] = ($event: any) => (_ctx.filterData.consolidator = $event)),
                    _ctx.onChange
                  ],
                  class: "mb-2"
                }, null, 8, ["isLoading", "options", "modelValue", "onUpdate:modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isHubList)
        ? (_openBlock(), _createBlock("div", _hoisted_23, [
            _hoisted_24,
            _createVNode("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _createVNode(_component_SelectSearch, {
                  onChevron: _cache[16] || (_cache[16] = e => (_ctx.isChevron = e)),
                  onFilter: _cache[17] || (_cache[17] = e => _ctx.fetchOriginDestination(e, 'code')),
                  onFocus: _cache[18] || (_cache[18] = () => _ctx.fetchOriginDestination('', 'code')),
                  isLoading: _ctx.loadingOriginDestination,
                  options: _ctx.originListHub,
                  keyName: "name",
                  keyValue: "code",
                  placeholder: "Pilih kota hub",
                  modelValue: _ctx.filterData.originCity,
                  "onUpdate:modelValue": [
                    _cache[19] || (_cache[19] = ($event: any) => (_ctx.filterData.originCity = $event)),
                    _ctx.onChange
                  ],
                  class: "mb-2"
                }, null, 8, ["isLoading", "options", "modelValue", "onUpdate:modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 512), [
      [_vShow, _ctx.openFilter && !_ctx.isDisabled]
    ])
  ], 2)), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isChevron) {
          _ctx.openFilter = true;
          _ctx.isChevron = false;
        } else if (_ctx.openFilter) {
          _ctx.openFilter = false;
        }
      }
    ]
  ])
}